// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__XdS1m","success":"styles_success__+S8jx","warning":"styles_warning__EAgfl","sm":"styles_sm__u30zi","md":"styles_md__NBFvr"};